<template>
  <el-popover
    placement="top"
    v-model="modalSelcetSpeed"
    :disabled="disabled"
    width="273"
  >
    <span
      v-for="(item, index) in speedRange"
      :key="index"
      :class="{ active: item == speedVal }"
      class="speed_block"
      @click="handleClick(item)"
      >{{ item }}</span
    >
    <a href="javascript:" class="play-speed" slot="reference">
      <i class="icon icon-speed"></i>
      {{ $t('common_text_control_speed') }}</a
    >
  </el-popover>
</template>

<script>
import { debounce } from 'debounce'
import { Popover } from "element-ui";

export default {
  name: 'ButtonPlaySpeed',
  components:{
    [Popover.name]: Popover
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    speedVal: {
      type: [Number, String],
      default: 1,
    },
  },
  data() {
    return {
      speedRange: [0.5, 0.75, 1, 1.25, 1.5],
      modalSelcetSpeed: false,
    }
  },
  methods: {
    handleClick: debounce(function (item) {
      this.modalSelcetSpeed = false
      this.$emit('click', item)
    }, 100),
  },
}
</script>

<style lang="scss" scoped>
.play-speed {
  font-size: 14px;
  margin-right: 20px;

  .icon {
    display: inline-block;
    width: 14px;
    height: 14px;
    vertical-align: -2px;
    margin-right: 4px;
  }
}

.speed_block {
  display: inline-block;
  width: 39px;
  height: 19px;
  text-align: center;
  border: 1px solid #1f2b38;
  border-radius: 2px;
  margin-right: 10px;
  cursor: pointer;
  &.active {
    background: #1882fe;
    border: 1px solid #6db1fe;
    color: #fff;
  }
}
</style>
